<ng-container [ngSwitch]="onlineResource.type">
  <ng-container *ngSwitchCase="OnlineResourceGoogleBooksType.GOOGLE_BOOKS">
    <a
      *ngIf="onlineResource.isbns?.length"
      [href]="onlineResource.preview_url"
      (click)="onlineResourceClicked()"
      target="_blank"
      rel="noopener"
      [attr.aria-describedby]="itemElementId"
    >
      <img
        [src]="googleBooksPlaceholder"
        alt="Google Preview"
        i18n-alt="@@onlineResourceButton-alt-googleBooks"
      />
    </a>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <ng-container [ngSwitch]="isPlayerResource">
      <ng-container *ngSwitchCase="true">
        <a
          *ngIf="absoluteUrl"
          [href]="absoluteUrl"
          (click)="onlineResourceClicked()"
          class="btn btn-xs btn-default"
          target="_blank"
          rel="noopener"
          i18n="@@onlineResourceButton-link-viewOnline"
          [attr.aria-describedby]="itemElementId"
        >
          View Online
        </a>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <a
          *ngIf="absoluteUrl"
          [href]="absoluteUrl"
          (click)="onlineResourceClicked()"
          class="btn btn-xs btn-default"
          target="_blank"
          rel="noopener"
          i18n="@@onlineResourceButton-link-viewOnline"
          [attr.aria-describedby]="itemElementId"
        >
          View Online
        </a>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
